import React, { useState, useEffect, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';

// Free-form user note on a single transaction. Mirrors the other transaction
// edit dialogs (Merchant / Flag / Source) — a small MUI dialog wired through the
// shared muiTheme so it inherits design tokens. Kept intentionally minimal: one
// multiline field. Empty text clears the note.
const NOTE_MAX_LENGTH = 5000; // must match backend TRANSACTION_NOTE_MAX_LENGTH

const NotesEditDialog = ({
  open,
  onClose,
  onSave,
  notes = '',
  title = 'Edit Note',
}) => {
  const [value, setValue] = useState('');

  // Re-seed the field each time the dialog opens for a (possibly different)
  // transaction, so we never show a stale note from a previous row.
  useEffect(() => {
    if (open) {
      setValue(notes || '');
    }
  }, [open, notes]);

  const handleSave = useCallback(() => {
    onSave(value.trim());
  }, [onSave, value]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const overLimit = value.length > NOTE_MAX_LENGTH;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          maxRows={12}
          label="Note"
          placeholder="What was this transaction for? Add any context worth remembering."
          value={value}
          onChange={(e) => setValue(e.target.value)}
          error={overLimit}
          helperText={
            overLimit
              ? `Note is too long (${value.length}/${NOTE_MAX_LENGTH} characters).`
              : `${value.length}/${NOTE_MAX_LENGTH}`
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={overLimit}>
          Save Note
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotesEditDialog;
